import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  FiltersCollectionModel,
  ResellersModel,
} from '../models/ResellersModel'
import ResellersService from '../ResellersService'

export interface ResellersState {
  resellers: ResellersModel | null
}

const initialState: ResellersState = {
  resellers: null,
}

export const getResellersThunk = createAsyncThunk(
  'resellers/getResellersThunk',
  async (data: FiltersCollectionModel, { rejectWithValue }) => {
    try {
      return await ResellersService.getResellers(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const authSlice = createSlice({
  name: 'resellers',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getResellersThunk.fulfilled, (state, action) => {
        state.resellers = action.payload
      })

      .addCase(getResellersThunk.rejected, state => {
        state.resellers = null
      })
  },
})

export const { actions, reducer } = authSlice
